(function () {

    //console.log("Nav activated")

    const back = document.querySelector("#back-link")
    const mainnav = document.querySelector("#mainnav")
    const parallax = document.querySelector(".parallax.newsarticle > div")

    function viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    }

    function handleMainNavBackButtonClicks() {
        if (back) {
            var links = back.querySelectorAll("a");
            if (links) {
                links.forEach(link => {
                    link.addEventListener("click", (e) => {
                        e.preventDefault();
                        mainnav.querySelectorAll(".nav-item").forEach((navitem) => {
                            if (navitem.classList && navitem.classList.contains("open")) {
                                navitem.classList.remove("open");
                                if (!back.classList.contains("hide")) {
                                    back.classList.add("hide")
                                }
                            } else {
                                navitem.classList.remove("hide")
                            }
                        })
                        mainnav.querySelector(".contact").classList.remove("hide");
                    })
                })
            }
        }
    }

    handleMainNavBackButtonClicks()

    if (mainnav) {
        const toggle = mainnav.querySelector(".navbar-toggler")
        toggle.addEventListener("click", () => {
            window.scrollTo(0, 0);
        })

        window.addEventListener("scroll", () => {
            if (window.scrollY == 0) {
                mainnav.classList.remove("fixed");
            } else {
                if (viewport().width > 1200) {
                    if (!mainnav.classList.contains("fixed")) {
                        mainnav.classList.add("fixed");
                    }
                }
            }
        })


        mainnav.querySelectorAll(".nav-link").forEach(link => {
            link.addEventListener("click", (e) => {

                const navElement = link.closest(".nav-item")

                if (navElement.classList.contains("dropdown") && !navElement.classList.contains("open")) {
                    e.preventDefault();

                    // close the other ones
                    mainnav.querySelectorAll(".nav-link").forEach(nlink => {
                        const nElement = nlink.closest(".nav-item")
                        nElement.classList.remove("open");
                        if (viewport().width < 1200) {
                            nElement.classList.add("hide");
                        }
                    })
                    if (viewport().width < 1200) {
                        mainnav.querySelector(".contact").classList.add("hide")
                    }
                    navElement.classList.remove("hide");
                    navElement.classList.add("open");

                    if (viewport().width < 1200) {
                        if (back.classList.contains("hide")) {
                            back.classList.remove("hide")
                        }
                        window.scrollTo(0, 0);
                        mainnav.querySelector(".contact").classList.add("hide")
                    }
                }
            });
        });
    }


    /* Business site nav */

    const nav = document.getElementById("nav")
    let currentSelection = null
    let navBackBtn = null
    let promoPanel = null
    let linksPanel = null
    let lastScroll = 0;
    if (nav) {
        const navMain = nav.closest("#navmain");
        const toggle = navMain.querySelector(".navbar-toggler")
        toggle.addEventListener("click", () => {
            window.scrollTo(0, 0);
        })


        window.addEventListener("scroll", () => {
            if (window.scrollY == 0) {
                navMain.classList.remove("fixed");
                if (parallax && parallax.classList) {
                    parallax.classList.remove("fixed");
                }
            } else {
                if (parallax && parallax.classList) {
                    parallax.classList.add("fixed");
                }
                let currentScroll = window.scrollY;
                if (currentScroll - lastScroll > 0) {
                    navMain.classList.add("down")
                    navMain.classList.remove("up")
                } else {
                    navMain.classList.add("up")
                    navMain.classList.remove("down")
                }

                lastScroll = currentScroll;
                if (!navMain.classList.contains("fixed")) {
                    navMain.classList.add("fixed");
                }
            }
        })

        navBackBtn = nav.querySelector(".nav-back");
        promoPanel = navMain.querySelector(".nav-promo")
        linksPanel = navMain.querySelector(".nav-links")

        // Set up arrows to show next level down
        const navArrows = nav.querySelectorAll(".arrow")
        if (navArrows) {
            for (let i = 0; i < navArrows.length; i++) {
                const arrow = navArrows[i];
                arrow.addEventListener("click", (e) => {
                    const navItem = e.target.closest(".nav-item")
                    const navSet = navItem.querySelector(".nav-set");
                    if (navSet != null) { // Sublinks are present
                        e.preventDefault();
                        setNavLevel(navItem.querySelector(".nav-link"))
                    }
                });
            }
        }

        // links show next level down
        //const navLinks = nav.getElementsByClassName("nav-link");
        //if (navLinks) {
        //    for (let i = 0; i < navLinks.length; i++) {
        //        const link = navLinks[i];
        //        link.addEventListener("click", (e) => {
        //            if (currentSelection != e.target) { // Clicking second time goes to the location
        //                const navItem = e.target.closest(".nav-item")
        //                const navSet = navItem.querySelector(".nav-set");
        //                if (navSet != null) { // Sublinks are present
        //                    e.preventDefault();

        //                    setNavLevel(navItem.querySelector(".nav-link"))
        //                }
        //            }

        //        });
        //    }
        //}
        nav.querySelector(".nav-back").addEventListener("click", function () {
            navBack()
        })
        navBack()
    }

    function resetNav() {
        promoPanel.classList.remove("active")
        navBackBtn.classList.remove("active")
        linksPanel.classList.add("active")

        nav.querySelector(".nav-set").classList.add("active");
        const children = nav.querySelector(".nav-set").childNodes;
        for (let i = 0; i < children.length; i++) {
            if (children[i].nodeType !== 1) {
                continue; // Skip non-element nodes
            }
            children[i].classList.add("active");
            children[i].querySelector(".nav-ctr").classList.add("active");
        }
    }

    function navBack() {
        // Clear all 
        removeSelected()
        removeActiveClass(nav.querySelectorAll(".nav-set"))
        removeActiveClass(nav.querySelectorAll(".nav-item"))
        removeActiveClass(nav.querySelectorAll(".nav-ctr"))

        const arrows = nav.querySelectorAll(".arrow")
        for (let i = 0; i < arrows.length; i++) {
            arrows[i].classList.remove("hide")
        }


        if (currentSelection) {
            // Set the current level to the level above current
            const currentNavItem = currentSelection.closest(".nav-item")
            const newNavSet = currentNavItem.closest(".nav-set")
            const newNavItem = newNavSet.closest(".nav-item")
            if (newNavItem) {
                const newCurrent = newNavItem.querySelector(".nav-ctr")
                setNavLevel(newCurrent)
                // Also set parent link to be active
                const parentNavItem = newNavItem.closest(".nav-item")
                if (parentNavItem) {
                    const parentLink = parentNavItem.querySelector(".nav-ctr")
                    if (parentLink) {
                        parentLink.classList.add("active")
                    }
                }
                setAncestorsActive(newNavItem)
            } else {
                currentSelection = null
                resetNav()
            }
        } else {
            resetNav()
        }
    }

    function setAncestorsActive(navItem) {
        if (navItem) {
            navItem.classList.add("active")
            const navSet = navItem.closest(".nav-set")
            navSet.classList.add("active")
            const parentNavItem = navSet.closest(".nav-item")
            setAncestorsActive(parentNavItem)
        }
    }

    function removeActiveClass(els) {
        for (let i = 0; i < els.length; i++) {
            els[i].classList.remove("active");
        }
    }

    function removeSelected() {
        const navItems = nav.querySelectorAll(".nav-item")
        for (let i = 0; i < navItems.length; i++) {
            navItems[i].classList.remove("selected")
        }
    }

    function setNavLevel(el) {
        if (el.classList.contains("top")) {
            promoPanel.classList.add("active")
            linksPanel.classList.remove("active")
        } else {
            promoPanel.classList.remove("active")
        }

        const arrow = el.parentNode.querySelector(".arrow")
        if (arrow) {
            arrow.classList.add("hide")
        }
        navBackBtn.classList.add("active")

        //console.log(el)
        currentSelection = el;
        const navItem = el.closest(".nav-item");

        // Remove selected from all other navitems
        removeSelected(navItem)
        // add selected to current
        navItem.classList.add("selected")
        // Show corresponding promos
        const selectedIndex = navItem.dataset.index;
        console.log("selectedIndex", selectedIndex)
        const promos = navItem.closest("#navmain").querySelectorAll(".promo-tile")
        for (let idx = 0; idx < promos.length; idx++) {
            promos[idx].classList.remove("active")
            console.log(promos[idx], promos[idx].dataset.index)
            if (promos[idx].dataset.index + "" == selectedIndex + "") {
                promos[idx].classList.add("active")
            }
        }


        // Set siblings of navItem to inactive
        navItem.parentNode.querySelectorAll(".nav-item").forEach(item => {
            if (item !== navItem) {
                item.classList.remove("active");
            }
        });
        // Hide Granddad
        granddad = navItem.parentNode.closest(".nav-item");
        //console.log(navItem, granddad, navItem == granddad)
        if (granddad) {
            granddad.querySelector(".nav-ctr").classList.remove("active");
        }

        const navSet = navItem.querySelector(".nav-set");
        navSet.classList.add("active");
        if (navSet) {
            const children = navSet.childNodes;
            for (let i = 0; i < children.length; i++) {
                if (children[i].nodeType !== 1) {
                    continue; // Skip non-element nodes
                }
                children[i].classList.add("active");
                children[i].querySelector(".nav-ctr").classList.add("active");
                //console.log(children[i])
            }

        }

    }

})();